"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnimationFrame = void 0;
var react_1 = require("react");
var useAnimationFrame = function (callback) {
    var requestRef = (0, react_1.useRef)();
    var previousTimeRef = (0, react_1.useRef)();
    var animate = function (time) {
        var _a;
        if (previousTimeRef.current !== undefined) {
            var deltaTime = time - ((_a = previousTimeRef.current) !== null && _a !== void 0 ? _a : 0);
            callback(deltaTime);
        }
        previousTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    };
    (0, react_1.useEffect)(function () {
        var request = requestAnimationFrame(animate);
        requestRef.current = request;
        return function () { return cancelAnimationFrame(request); };
    });
};
exports.useAnimationFrame = useAnimationFrame;
